window.__designerData = {
  "0": {
    "thumbnail": "//www.pabon.shop/cdn/shop/files/natisagrowthspurt.jpg?v=1774012378&width=400",
    "images": [
      "//www.pabon.shop/cdn/shop/files/natisagrowthspurt.jpg?v=1774012378&width=1200",
      "//www.pabon.shop/cdn/shop/files/triplet.jpg?v=1774012329&width=1200",
      ""
    ],
    "video": "",
    "videoAsThumbnail": false,
    "videoPreview": false,
    "startWithVideo": false,
    "paintingName": "Growth Spurt",
    "bio": "Natisa Jones is an artist between Bali and Amsterdam. Her worlds often depict female figurines, which often depict struggles of 'the woman in modern life'. She views color as a means to emphasise or contrast the subjects on her canvas.",
    "wikipedia": "https://www.natisajones.com",
    "enabled": true,
    "available": true,
    "designerName": "Natisa Jones",
    "colors": [
      { "name": "Dark Red", "hex": "#930918", "woolCode": "4M0994" },
      { "name": "Crimson", "hex": "#6c1920", "woolCode": "4M0778" },
      { "name": "Bright Red", "hex": "#c32728", "woolCode": "4E1543" },
      { "name": "Peach", "hex": "#f3dbd6", "woolCode": "4E2763" },
      { "name": "Cream", "hex": "#f3f2df", "woolCode": "2m1653" },
      { "name": "Black", "hex": "#170909", "woolCode": "9E1048" }
    ],
    "woolImages": [
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor1_29935914-9ede-42a9-8de4-aaea2b54756e.jpg?v=1767357939&width=600",
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor2.jpg?v=1767356412&width=600",
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor3.jpg?v=1767356413&width=600",
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor6.jpg?v=1767356413&width=600",
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor5.jpg?v=1767356412&width=600",
      "//www.pabon.shop/cdn/shop/files/natisawoolcolor4.jpg?v=1767356413&width=600"
    ],
    "garmentImages": [
      "",
      "",
      ""
    ],
    "garmentVideo": "",
    "defaultPattern": ""
  },
  "1": {
    "thumbnail": "//www.pabon.shop/cdn/shop/files/nasa.jpg?v=1770043154&width=400",
    "images": [
      "//www.pabon.shop/cdn/shop/files/natisa2.jpg?v=1771855664&width=1200",
      "//www.pabon.shop/cdn/shop/files/Screenshot_2026-03-20_at_14.06.38.png?v=1774347959&width=1200",
      "//www.pabon.shop/cdn/shop/files/Screenshot_2026-03-20_at_14.06.46.png?v=1774347961&width=1200"
    ],
    "video": "",
    "videoAsThumbnail": false,
    "videoPreview": false,
    "startWithVideo": false,
    "paintingName": "",
    "bio": "Natisa Jones is an artist between Bali and Amsterdam. Her worlds often depict female figurines, which often depict struggles of 'the woman in modern life'. She views color as a means to emphasise or contrast the subjects on her canvas.",
    "wikipedia": "https://www.natisajones.com",
    "enabled": true,
    "available": true,
    "designerName": "Natisa Jones 2",
    "colors": [
      { "name": "Coffee", "hex": "#413735", "woolCode": "7M0088" },
      { "name": "Mocha", "hex": "#524841", "woolCode": "7M0912" },
      { "name": "Merlot", "hex": "#5f2e39", "woolCode": "4E4646" },
      { "name": "Pistache", "hex": "#c4cab2", "woolCode": "6M1825" },
      { "name": "Ocean Blue", "hex": "#f3c6d9", "woolCode": "4M1846" },
      { "name": "Lavender", "hex": "#2898b6", "woolCode": "4E2763" }
    ],
    "woolImages": [
      "//www.pabon.shop/cdn/shop/files/natisa2merlot.jpg?v=1770391142&width=600",
      "//www.pabon.shop/cdn/shop/files/pistache.jpg?v=1770391142&width=600",
      "//www.pabon.shop/cdn/shop/files/natisa2blue.jpg?v=1770391143&width=600",
      "//www.pabon.shop/cdn/shop/files/natisa2brown1.jpg?v=1770391142&width=600",
      "//www.pabon.shop/cdn/shop/files/natisa2pink.jpg?v=1770391142&width=600",
      "//www.pabon.shop/cdn/shop/files/natisa2brown2.jpg?v=1770391142&width=600"
    ],
    "garmentImages": [
      "",
      "",
      ""
    ],
    "garmentVideo": "",
    "defaultPattern": ""
 },
  "sizing": {
    "slides": [
      { "type": "video", "src": "//www.pabon.shop/cdn/shop/videos/c/vp/119371e32a494ba68240744b307d2d85/119371e32a494ba68240744b307d2d85.m3u8?v=0" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop3246size.jpg?v=1775067914&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop3411_b2d90b1f-88ed-4f46-b5af-ae78a910c9c6.jpg?v=1775150944&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop1045.jpg?v=1775067915&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop9774.jpg?v=1776334695&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop2957double.jpg?v=1776351843&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/DSC06403.jpg?v=1776589241&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop6486c.jpg?v=1776334737&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/oltre_493size.jpg?v=1776334760&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/greatest_28maart8163b.jpg?v=1776015063&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/DSC03243size.jpg?v=1776364772&width=1200" },
      { "type": "image", "src": "//www.pabon.shop/cdn/shop/files/pabon_shop9739size.jpg?v=1776334973&width=1200" }
    ],
    "description": "Oversized sweater. Size down if you want a more fitted look.\nSIZING GUIDELINES: \n186-198 cm: L \n186-178cm: M  \n176 - 170cm: S\n169-160cm XS."
  },
  "garment": {
    "images": [
      "//www.pabon.shop/cdn/shop/files/greatest_28maart6190.jpg?v=1775414338&width=1200",
      "//www.pabon.shop/cdn/shop/files/pabon_shop1045c.jpg?v=1775804536&width=1200",
      "//www.pabon.shop/cdn/shop/files/replace_the_colors_of_the_swea_Nano_Banana_2_46669.jpg?v=1777837543&width=1200",
      "//www.pabon.shop/cdn/shop/files/DSC03353.jpg?v=1775757953&width=1200",
      "//www.pabon.shop/cdn/shop/files/DSC03106b.jpg?v=1775757922&width=1200",
      "//www.pabon.shop/cdn/shop/files/oltre_493b.jpg?v=1775757948&width=1200",
      "//www.pabon.shop/cdn/shop/files/pabon_shop3246b.jpg?v=1775394889&width=1200"
    ],
    "video": ""
  }
};